import { render, staticRenderFns } from "./OutpatientZone.vue?vue&type=template&id=a704e1be&scoped=true"
import script from "./OutpatientZone.vue?vue&type=script&lang=js"
export * from "./OutpatientZone.vue?vue&type=script&lang=js"
import style0 from "./OutpatientZone.vue?vue&type=style&index=0&id=a704e1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a704e1be",
  null
  
)

export default component.exports